import { BrowserRouter, Switch, Route, HashRouter } from 'react-router-dom';

import React, { Component } from 'react';
import HelpdeskApiCall from 'HelpdeskApiCall';
import config from 'config';
import Spinner from 'HELPDESK/CommonResources/SpinnerLoader/Spinner';
import Dashboard from 'HELPDESK/Components/Dashboard/Dashboard';
import ModulePresentation from 'HELPDESK/Components/CoordinatorDetails/ModulePresentation';
import NotFound from 'HELPDESK/CommonResources/NotFound/NotFound';
import ProductDocumentation from 'HELPDESK/Components/ProductDocumentation/ProductDocumentation';

export class RoutesSetup extends Component {

    render() {
        return (
            <>
                <HashRouter>
                    <Switch>
                        <Route exact path="/" component={Dashboard} />
                        <Route exact path="/help/:key" component={ProductDocumentation} />
                        <Route exact path="/:module" component={ModulePresentation} />
                        <Route path="*" component={NotFound} />
                    </Switch>
                </HashRouter>
            </>
        )
    }
}

export default RoutesSetup;
